var projects_ready;

projects_ready = function () {
  return $(".project-toggler").on("click", function (e) {
    var $this, offset;
    e.preventDefault();
    $this = $(this);
    if ($this.data("toggle-target") === "#project-images") {
      $(".coucou-slider").show();
      if ($("#project-images").hasClass("horizontal")) {
        offset = $("#" + $(this).data("slide-id")).offset();
        $("html,body").animate({
          scrollLeft: offset.left - 200,
        });
      }
    } else {
      $(".coucou-slider").hide();
    }
    $("" + $this.data("toggle-target")).addClass("active");
    return $(".project-toggle-target")
      .not("" + $this.data("toggle-target"))
      .removeClass("active");
  });
};

$(document).ready(projects_ready);

$(document).on("page:load", projects_ready);

// ---
// generated by coffee-script 1.9.2
